'use strict';

import React from 'react';
import Link from './Link';
import PureRenderMixin from '../mixins/PureRenderMixin';
import { PropTypes } from 'react';
import getStampSegment from '../utils/getStampSegment';

var StampLink = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    stamp: PropTypes.object.isRequired,
    showTitle: PropTypes.bool,
    routeName: PropTypes.string.isRequired,
    routeParams: PropTypes.object,
    bold: PropTypes.bool,
    className: PropTypes.string,
    target: PropTypes.oneOf(['_blank'])
  },

  getDefaultProps() {
    return {
      routeName: 'feedStamp'
    };
  },

  getLinkTitle() {
    const { showTitle, stamp } = this.props;
    if (!showTitle) {
      return;
    }

    return stamp.title;
  },

  render() {
    const title = this.getLinkTitle();
    const { className, routeName, routeParams, stamp, bold, underline, target, children } = this.props;
    const params = {
      stampSegment: getStampSegment(stamp),
      ...routeParams
    };

    return (
      <Link {...{ className, to: routeName, bold, underline, target, params, title }}>
        {children || stamp.title}
      </Link>
    );
  }
});

export default StampLink;



/** WEBPACK FOOTER **
 ** ./atoms/StampLink.jsx
 **/